import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  createSoaCreditNote: function (soaCreditNote) {
    soaCreditNote.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('soacreditnotes', soaCreditNote)
  },
  generateCreditNotes: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('soacreditnotes/pdf/' + id)
  },
  getSoaCreditNotesById: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('soacreditnotes/' + id)
  },
  getSoaCreditNotes: function ({
    limit = 9999,
    page = 1,
    client,
    sort
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (sort) query.push(`sort[]=${sort}`)
    if (client) { return instCred.get('soacreditnotes?' + query.join('&')) }
  },
  getTotalCreditNote: function (client) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company'),
        'client': client
      }
    })
    if (client) return instCred.get('soacreditnotes/total')
  }
}



// WEBPACK FOOTER //
// ./src/api/SoaCreditNote/api.js